import React from 'react'
import { useState } from 'react';
import LocationAutocomplete from './LocationAutocomplete';
import LocationDetails from './LocationDetails';

const AddressAutoComplete = () => {
    const [locationData, setLocationData] = useState(null);

    return (
        <>

            <div style={{ padding: "20px", maxWidth: "600px", margin: "auto" }}>
                <h2>Google Places Autocomplete</h2>
                <LocationAutocomplete onPlaceSelected={setLocationData} />
                <LocationDetails data={locationData} />
            </div>
        </>
    )
}

export default AddressAutoComplete